import type { TSystemColumn } from "../lib/portfolioStorage";

export const STATUS_FILTER_KEY = "__status__";
export const OWNER_FILTER_KEY = "__owner__";
export const MODIFIED_BY_FILTER_KEY = "__modifiedBy__";
export const EMPTY_VALUE_TOKEN = "__empty__";
export const HAS_VALUE_TOKEN = "__has_value__";
export const STATUS_OPTIONS = ["Framing", "Generating", "Complete", "Failed"] as const;

export const STATUS_DOT_COLORS: Record<(typeof STATUS_OPTIONS)[number], string> = {
  Framing: "#e6a539",
  Generating: "#ff603e",
  Complete: "#489c50",
  Failed: "#d93d3d"
};

export const STATUS_LABEL_KEYS = {
  Framing: "status.options.framing",
  Generating: "status.options.generating",
  Complete: "status.options.complete",
  Failed: "status.options.failed"
} as const satisfies Record<TPortfolioStatus, string>;

export const FILTER_CHECKBOX_CLASS =
  "rounded-[4px] border border-[#e4e4e7] bg-transparent data-[state=checked]:border-transparent data-[state=checked]:bg-[#18181b] [&_svg]:h-3 [&_svg]:w-3";
export type TPortfolioStatus = (typeof STATUS_OPTIONS)[number];

export const SYSTEM_COLUMNS = [{ id: "version", labelKey: "card.version" }] as const satisfies readonly {
  id: TSystemColumn;
  labelKey: string;
}[];

export const ALL_SYSTEM_COLUMN_IDS: TSystemColumn[] = SYSTEM_COLUMNS.map((c) => c.id);

export const DIMENSION_PRESET_SWATCHES = [
  "#3367e5",
  "#22a8dc",
  "#22c55e",
  "#84cc16",
  "#eab308",
  "#f97316",
  "#ec4899",
  "#ef4444",
  "#a855f7",
  "#6b7280"
];
